import React, { useEffect } from "react";
import ReactPixel from "react-facebook-pixel";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Container,
  ResponsiveContainer,
  Card,
  CardList,
  P,
  Icon,
  Header,
  H2,
} from "./styles";
import { TProductsPage } from "../../@types/pages/TProductsPage";
import { TDispatch } from "../../@types/TDispatch";
import { getWhiteLabelGroupsSelector } from "../../store/selectors";
import { TGlobalState } from "../../@types/State/TGlobalState";
import { TWhiteLabelGroupProduct } from "../../@types/Entities/TWhiteLabelGroupEntity";

const Products: React.FC<TProductsPage> = ({ getWhiteLabelGroupState }) => {
  useEffect(() => {
    ReactPixel.pageView();
  }, []);

  const getSalesLink = (d: TWhiteLabelGroupProduct) => {
    const home = d.urls.find((item) => item.name === "home");
    if (home) {
      return home.url + window.location.search;
    }
    return d.urls[0].url + window.location.search;
  };

  const renderProducts = () => {
    if (getWhiteLabelGroupState.data?.products.length) {
      return getWhiteLabelGroupState.data.products.map(
        (d: TWhiteLabelGroupProduct, i: number) => (
          <a href={getSalesLink(d)}>
            <Card key={d.name} id={`productList_product-${i}`}>
              <Icon id={`product-${d.name}`} name={d.icon} />
              <P>{d.label}</P>
            </Card>
          </a>
        )
      );
    }
    return <></>;
  };

  return (
    <Container>
      <ResponsiveContainer>
        <Header>
          <H2>Seguros</H2>
          <P>Escolha seu seguro</P>
        </Header>
        <CardList id="productList">{renderProducts()}</CardList>
      </ResponsiveContainer>
    </Container>
  );
};

const mapStateToProps = (state: TGlobalState) => {
  return {
    getWhiteLabelGroupState: getWhiteLabelGroupsSelector(state),
  };
};

const mapDispatchtoProps = (dispatch: TDispatch) =>
  bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchtoProps)(Products);
